
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  filters,
})
export default class ComingSoon extends Vue {}
